/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Recording_Denied_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo was in the meeting but did not get permission to record." |
*
* @param {Meeting_Notetaker_Issue_Recording_Denied_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_recording_denied_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Recording_Denied_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Recording_Denied_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo zat in de meeting, maar kreeg geen toestemming om op te nemen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo était dans la réunion, mais n'a pas reçu l'autorisation d'enregistrer.")
	return /** @type {LocalizedString} */ ("Wundo was in the meeting but did not get permission to record.")
});